import React from "react";
// import { Button as ShadcnButton } from "@/components/ui/button";
import { Button } from "@headlessui/react";

const CustomButton = ({ children, className, variant = "default", size = "default", ...props }) => {
    return (
        <Button
            variant={variant}
            size={size}
            className={`rounded-xl font-semibold", ${className}`}
            {...props}
        >
            {children}
        </Button>
    );
};

export default CustomButton;
